/*
 *  Bootstrap Nice Select Bulgarian (Bulgaria) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['bg-BG'] = localisation.locales['bg'] = {
    formatSearch() {
        return "Търсене...";
    },
    formatHelpForTagging() {
        return "3a създаване на собствени тагове фокусирайте полето за въвеждане и след това натиснете 'Enter' или ',' или 'Интервал', за да ro добавите към списъка";
    }
}

export default localisation;